/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

function SEO({ metaDescription, lang, meta, title }) {
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: 'viewport',
          content:
            'minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no',
        },
      ].concat(meta)}
    >
      <script type="text/javascript">
        {typeof window !== 'undefined'
          ? (function(w, c, t, u) {
              w._wct = w._wct || {};
              w._wct = u;
              var s = c.createElement(t);
              s.type = 'text/javascript';
              s.async = true;
              s.src = 'https://wct-2.com/wct.js';
              var r = c.getElementsByTagName(t)[0];
              r.parentNode.insertBefore(s, r);
            })(window, document, 'script', {
              uid: 'MXcDDy',
              google_tracking_id: 'UA-143247178-1',
              proxy: 'https://wct-2.com',
            })
          : null}
      </script>

      <link rel="preload" href="https://wct-2.com/wct.js" as="script" />
    </Helmet>
  );
}

SEO.defaultProps = {
  lang: `no`,
  meta: [],
  metaDescription: ``,
};

SEO.propTypes = {
  metaDescription: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default SEO;
